//----------------------------------------------
//get the map
//----------------------------------------------

import { ReinosMaps } from '../../core'

ReinosMaps.prototype.getMap = function (id) {
  if (this._map_[id] !== undefined) {
    return this._map_[id]
  }
  return false
}
